const { createRouter, createWebHashHistory, createWebHistory } = require("vue-router");

export const routes = [
    {
        path: '/',
        title: '首页',
        component: ()=>import('../views/Home')
    },
    {
        path: '/detail',
        title: '详情',
        name: 'Detail',
        component: ()=>import('../views/Detail'),
        hidden: true
    },
    {
        path: '/NFT',
        title: '什么是数字藏品',
        component: ()=>import('../views/NFT')
    },
    {
        path: '/aboutus',
        title: '关于我们',
        component: ()=>import('../views/AboutUs')
    },
    { 
        path: '/:pathMatch(.*)*', 
        title: '404',
        hidden: true,
        name: 'not-found', 
        component: ()=>import('../views/Home') 
    },
]

const router = createRouter({
    history: createWebHistory(),
    // history: createWebHashHistory(),
    routes
})


export default router